module.exports = __webpack_public_path__ + "fonts/Roboto-SemiBold.33a2cec.woff2";